import React from 'react';
import Routes from 'root/routes';
import { ReactComponent as OrcIcons } from '@ontruck/orc/lib/orc.svg';
import { OrcProvider, GlobalStyles as OrcGlobalStyles } from '@ontruck/orc';
import { themeBaseOverwrite, GlobalStyles } from 'utils/style';
import { ProvideAuth } from 'hooks/useAuth/useAuth';
import { ProvideChat } from 'hooks/useConversation/useConversation';
import { SWRConfig } from 'swr';
import 'i18n/index';

const Root = () => {
  return (
    <OrcProvider themeBase={themeBaseOverwrite}>
      <ProvideAuth>
        <ProvideChat>
          <SWRConfig
            value={{
              dedupingInterval: 8000
            }}
          >
            <Routes />
            <OrcIcons />
            <OrcGlobalStyles />
            <GlobalStyles />
          </SWRConfig>
        </ProvideChat>
      </ProvideAuth>
    </OrcProvider>
  );
};

export default Root;
